import React from 'react';
import { PropTypes } from 'prop-types';

import { PlayPauseButton } from './PlayPauseButton';
import { useVideoState } from './hooks';

const Video = ({ styles, src, poster, hideControls, autoPlay, customRef, onPlayClick, eventId, large }) => {
    const [isPlaying, handleClick, ref, buttonClicked] = useVideoState(customRef, onPlayClick);
    const containerRef = React.useRef(null);

    return (
        <div className={styles.container} data-event-id={eventId} ref={containerRef}>
            {/* eslint-disable-next-line */}
            <video
                className={styles.video}
                muted={autoPlay}
                playsInline={autoPlay}
                autoPlay={autoPlay}
                poster={poster}
                ref={ref}
                controls={hideControls ? false : buttonClicked}
            >
                <source src={src} type="video/mp4" />
            </video>
            {hideControls ? null : (
                <PlayPauseButton large={large} onClick={handleClick} isPlaying={isPlaying} shouldShow={!isPlaying} />
            )}
        </div>
    );
};

Video.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
        video: PropTypes.string.isRequired,
    }).isRequired,
    src: PropTypes.string.isRequired,
    poster: PropTypes.string,
    hideControls: PropTypes.bool,
    autoPlay: PropTypes.bool,
    customRef: PropTypes.shape(),
    onPlayClick: PropTypes.func,
    eventId: PropTypes.string,
    large: PropTypes.bool,
};

Video.defaultProps = {
    poster: null,
    hideControls: false,
    autoPlay: false,
    customRef: null,
    onPlayClick: () => {},
    eventId: undefined,
    large: false,
};

export default Video;
